import { lastDateToCurrentDate, currentDateToNextDate } from "./daysFunction";
import { lastWeekToCurrent, currentWeekToNextWeek } from "./weekFunction";
import {
    lastMonthToCurrentWeek,
    currentMonthToNextMonth,
} from "./monthsFunction";
import {
    lastQuarterToCurrenQuarter,
    currentQuarterToNextQuarter,
} from "./quarterFunction";
import { lastYearToCurrentYear, currentYearToNextYear } from "./yearsFunction";

const lastToNextDateFunction = ({ period, value, unit }) => {
    const dateFunctions = {
        Days: {
            Last: lastDateToCurrentDate,
            Next: currentDateToNextDate,
        },
        Weeks: {
            Last: lastWeekToCurrent,
            Next: currentWeekToNextWeek,
        },
        Months: {
            Last: lastMonthToCurrentWeek,
            Next: currentMonthToNextMonth,
        },
        Quarters: {
            Last: lastQuarterToCurrenQuarter,
            Next: currentQuarterToNextQuarter,
        },
        Years: {
            Last: lastYearToCurrentYear,
            Next: currentYearToNextYear,
        },
    };

    // Check if the function exists for the given period and unit
    const dateFunction = dateFunctions[unit]?.[period];
    if (dateFunction) {
        const { formattedStartDate, formattedEndDate } = dateFunction(value);
        return { minValue: formattedStartDate, maxValue: formattedEndDate };
    }

    return { minValue: null, maxValue: null }; // Default return for unsupported cases
};

export { lastToNextDateFunction };
